export default "__VITE_ASSET__BES$EPoG__"